import SelectService from '../selectService'
import { Form, Row } from 'antd'
import { Select } from 'components/atoms'
import InputSearch from 'components/atoms/inputSearch'
import { STATUS_OPTIONS } from 'constants/options'
import { useUtil } from 'hooks'
import styled from 'styled-components'

const StyledFormItem = styled(Form.Item)`
  margin-right: 12px;
  display: flex;
  align-items: end;
  margin-bottom: 0;
`
interface IProps {
  onClick?: () => void
  children?: React.ReactNode
  onSearch?: (value: any) => void
}

const DefaultFormFilter = (props: IProps) => {
  const { onSearch = () => {} } = props
  const [form] = Form.useForm()
  const { getOptions } = useUtil()

  return (
    <Form form={form}>
      <Row>
        <StyledFormItem name="service">
          <SelectService
            isGetAllServices={true}
            onChange={(id: number) => onSearch(form.getFieldsValue())}
          />
        </StyledFormItem>
        <StyledFormItem name="status">
          <Select
            title="status"
            placeholder="please-select-status"
            options={getOptions(STATUS_OPTIONS)}
            onChange={() => onSearch(form.getFieldsValue())}
          />
        </StyledFormItem>
        <StyledFormItem name="search">
          <InputSearch search={() => onSearch(form.getFieldsValue())} />
        </StyledFormItem>
      </Row>
    </Form>
  )
}

export default DefaultFormFilter
